import { DropdownMenu } from 'radix-ui';

import DropdownItem from './DropdownItem';

type Props = {
  items: { label: string; value: string }[];
  onValueChange: (value: string) => void;
  value: string;
};

const FilterButtonRadioGroup = ({ items, onValueChange, value }: Props) => {
  return (
    <DropdownMenu.RadioGroup onValueChange={onValueChange} value={value}>
      {items.map((item) => (
        <DropdownMenu.RadioItem
          asChild={true}
          key={item.value}
          onSelect={(ev) => ev.preventDefault()}
          value={item.value}
        >
          <DropdownItem label={item.label} withRadioCheck={true} />
        </DropdownMenu.RadioItem>
      ))}
    </DropdownMenu.RadioGroup>
  );
};

export default FilterButtonRadioGroup;
